/**
 * Bulk Operation Card Component
 * Displays individual bulk operation information
 */

import React from 'react';
import { enhancedInvoiceService } from '../../services/enhancedInvoiceService';

const BulkOperationCard = ({ 
  operation, 
  onSelect, 
  onApprove, 
  onCancel, 
  canManage, 
  isProcessing 
}) => {
  const statusBadge = enhancedInvoiceService.getOperationStatusBadge(operation);
  const progress = enhancedInvoiceService.calculateOperationProgress(operation);

  const canApprove = canManage && operation.status === 'pending';
  const canCancel = canManage && ['pending', 'approved', 'in_progress'].includes(operation.status);

  return (
    <div className="bulk-operation-card" onClick={() => onSelect(operation)}>
      <div className="card-header">
        <div className="card-title">
          <h3>{operation.title}</h3>
          <span className={`status-badge ${statusBadge.class}`}>
            {statusBadge.text}
          </span>
        </div>
        <div className="card-actions">
          {canApprove && (
            <button
              className="btn btn-sm btn-success"
              onClick={(e) => {
                e.stopPropagation();
                onApprove(operation.id);
              }}
              disabled={isProcessing}
            >
              Approve
            </button>
          )}
          {canCancel && (
            <button
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                e.stopPropagation();
                onCancel(operation.id);
              }}
              disabled={isProcessing}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
      
      <div className="card-content">
        <div className="operation-details">
          <div className="detail-item">
            <span className="detail-label">Type:</span>
            <span className="detail-value">{operation.operation_type}</span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Members:</span>
            <span className="detail-value">
              {operation.processed_members}/{operation.total_members}
            </span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Progress:</span>
            <span className="detail-value">{progress}%</span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Amount:</span>
            <span className="detail-value">${operation.invoice_amount}</span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Created:</span>
            <span className="detail-value">
              {operation.created_at ? 
                new Date(operation.created_at).toLocaleString() : 
                'Unknown'
              }
            </span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Created By:</span>
            <span className="detail-value">{operation.created_by || 'System'}</span>
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="progress-section">
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="progress-text">{progress}% Complete</span>
        </div>
        
        {/* Description */}
        {operation.description && (
          <div className="operation-description">
            <span className="description-label">Description:</span>
            <span className="description-text">{operation.description}</span>
          </div>
        )}
        
        {/* Error Summary */}
        {operation.error_summary && Object.keys(operation.error_summary).length > 0 && (
          <div className="error-summary">
            <span className="error-label">Errors:</span>
            <div className="error-items">
              {Object.entries(operation.error_summary).map(([key, value]) => (
                <span key={key} className="error-item">
                  {key}: {value}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkOperationCard;
